module.exports = __webpack_public_path__ + "img/image_028.434e7a9c.jpeg";